import {AccountError} from "@enums/ServerErrorCodes";
import {FirebaseService} from "@/services/firebase/FirebaseService";
import {FirebaseEvents} from "@/services/firebase/analytics/FirebaseEvents";
import FirebaseEventBuilder from "@/services/firebase/analytics/FirebaseEventBuilder";
import LogService from "@/services/log-service/LogService";
import {f7} from "framework7-vue";
import {ServiceCoreApiResponseError} from "@/services/v2/service-core-api/errors/ServiceCoreApiResponseError";
import i18n from "@/langs/i18n";
import CreatePaymentViewController from "@/targets/light/views/create-payment/ts/CreatePaymentViewController";
import LightPaymentPidResponseError from "@models/responses/light-payment-pid/LightPaymentPidResponseError";

export default class CreatePaymentErrorHandler {
	private static _instance: CreatePaymentErrorHandler | null = null;

	public static of() {
		if (!CreatePaymentErrorHandler._instance) {
			CreatePaymentErrorHandler._instance = new CreatePaymentErrorHandler();
		}

		return CreatePaymentErrorHandler._instance;
	}

	public handle(error: ServiceCoreApiResponseError | Error | unknown) {
		if (error instanceof ServiceCoreApiResponseError) {
			const controller = CreatePaymentViewController.of();

			switch (error.code) {
				case AccountError.AgentsUnavailableForAmount:
					LogService.of().log("CreatePaymentErrorHandler@handle", AccountError.AgentsUnavailableForAmount);
					FirebaseService.of().analyticsEvent(
						FirebaseEvents.PAYMENT_ERROR_WRONG_RANGE,
						FirebaseEventBuilder.of().build()
					);
					FirebaseService.of().wrongRangeMetricSuccess.startObserve();
					//@ts-ignore
					f7.dialog.alert(i18n.global.t('light-payment.errors.default.description', { code: AccountError.AgentsUnavailableForAmount }), i18n.global.t('light-payment.errors.default.title'));
					break;

				case AccountError.AgentsUnavailableForRangeAmount:
					LogService.of().log("CreatePaymentErrorHandler@handle", AccountError.AgentsUnavailableForRangeAmount);
					FirebaseService.of().analyticsEvent(
						FirebaseEvents.PAYMENT_ERROR_EMPTY_RANGE,
						FirebaseEventBuilder.of().build()
					);
					FirebaseService.of().emptyRangeMetricSuccess.startObserve();
					controller.paymentService.paymentError = new LightPaymentPidResponseError(error.code, error.data);

					controller.routerService.toViewSelectAgentForLight();
					break;

				case AccountError.AgentsAmountBetweenRanges:
					FirebaseService.of().emptyRangeMetricSuccess.startObserve();
					console.log(error.data)
					controller.paymentService.paymentError = new LightPaymentPidResponseError(error.code, error.data);
					break;

				case AccountError.AgentNotFound:
					FirebaseService.of().analyticsEvent(
						FirebaseEvents.PAYMENT_ERROR_NO_AGENTS,
						FirebaseEventBuilder.of().build()
					);
					//@ts-ignore
					f7.dialog.alert(i18n.global.t('light-payment.errors.default.description', { code: AccountError.AgentNotFound }), i18n.global.t('light-payment.errors.default.title'));
					break;
				default:
					f7.dialog.alert(i18n.global.t('light-payment.errors.default.description', { code: error.code }), i18n.global.t('light-payment.errors.default.title'));
					break;
			}
		} else {
			//@ts-ignore
			f7.dialog.alert(i18n.global.t('g.errors.alert.default-text'), i18n.global.t('g.errors.alert.default-title'));
		}
	}
}
